<template>
	<div>
		<h1>Theme Console</h1>
	</div>
</template>

<script>
export default {
	// props: [],
	data() {
		return {
			count: 0
		}
	},
	mounted() {
		console.log('Theme console: All set')
	}
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/admin/assets/js/app/themes/ThemeConsole.vue